import Vue from 'vue'
import App from './App.vue'

import axios from 'axios';
import ElementUI from 'element-ui';
import VueAMap from "vue-amap";
// import amap from './assets/amap'
import tools from './tools'

Vue.use(tools);

import VDistpicker from 'v-distpicker'
Vue.component('v-distpicker', VDistpicker);


import Print from 'vue-print-nb'
Vue.use(Print)

import dataV from '@jiaminghi/data-view'
Vue.use(dataV)

import { borderBox1 } from '@jiaminghi/data-view'

Vue.use(borderBox1)

import echarts from 'echarts'
Vue.prototype.$echarts = echarts

// main.js
// import VeRing from 'v-charts/lib/ring.common'// 环形图
// //
// // Vue.component(VeRing.name, VeRing)
import AMap from 'vue-amap'
Vue.use(AMap)

AMap.initAMapApiLoader({
  key: 'b7b37a6cb0694c6a8e1431adaa9e957b', // 必填
  plugin: ['AMap.Geolocation'], // 加载插件
  v: '1.4.15' // 版本号，默认为 1.4.15
})



// import {lazyAMapApiLoaderInstance} from 'vue-amap';

import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel',JsonExcel);

// Vue.use(VueAMap);
// VueAMap.initAMapApiLoader({
//     key: "b47d504136bc47bb78f79f3b4bedd701",
//     plugin: [
//         "AMap.Autocomplete", //输入提示插件
//         "AMap.PlaceSearch", //POI搜索插件
//         "AMap.Scale", //右下角缩略图插件 比例尺
//         "AMap.OverView", //地图鹰眼插件
//         "AMap.ToolBar", //地图工具条
//         "AMap.MapType", //类别切换控件，实现默认图层与卫星图、实施交通图层之间切换的控制
//         "AMap.PolyEditor", //编辑 折线多，边形
//         "AMap.CircleEditor", //圆形编辑器插件
//         "AMap.Geolocation" //定位控件，用来获取和展示用户主机所在的经纬度位置
//     ],
//     uiVersion: "1.0",
//     // 默认高德 sdk 版本为 1.4.4
//     v: '1.4.4'
// });
// lazyAMapApiLoaderInstance.load().then(() => {
//     // your code ...
//     this.map = new AMap.Map('amapContainer', {
//         center: new AMap.LngLat(102.748965, 25.08184)
//     });
// });
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
import "./assets/css/main.css";
// import '../static/css/theme-green/index.css';       // 浅绿色主题
import './assets/css/icon.css';
import './view/common/directives';
import "babel-polyfill";

Vue.use(require('vue-moment')); //日期时间格式化
import md5 from 'js-md5'

Vue.prototype.$md5 = md5;

//Vue.use(VueQuillEditor)


//Vue.use(VueDND)
import VueParticles from 'vue-particles'

Vue.use(VueParticles)
import kc from './kc'


import router from './config/vueRouter'
import vueConfig from './config/vueConfig'

Vue.prototype.vueConfig = vueConfig
Vue.config.productionTip = false
Vue.use(ElementUI, {
    size: 'small'
});

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
// Vue.use(Viewer)
Vue.use(Viewer, {
    defaultOptions: {
        zIndex: 999999999
    }
})
axios.defaults.timeout = 1000 * 60 * 10
axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8'
axios.interceptors.request.use(config => {    // 这里的config包含每次请求的内容
    config.withCredentials = true;// 允许携带cookie
    var url = vueConfig.apiUrl
    // if (vueConfig.apiUrl > 0) {
    //     url = url + ":" + vueConfig.apiUrl
    // } else {
    //     url = vueConfig.apiUrl;
    // }
    config.baseURL = url; //设置axios默认地址
    return config;
}, err => {
    return Promise.reject(err);
});
Vue.prototype.axios = axios;

//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
    const role = localStorage.getItem("loginSysUser");
    if (!role && to.path !== '/login') {
        next('/login');
    // } else if (to.meta.permission) {
    //     // 如果是管理员权限则可进入，这里只是简单的模拟管理员权限而已
    //     role === 'admin' ? next() : next('/403');
    } else {
        // 简单的判断IE10及以下不进入富文本编辑器，该组件不兼容
        if (navigator.userAgent.indexOf('MSIE') > -1 && to.path === '/editor') {
            Vue.prototype.$alert('vue-quill-editor组件不兼容IE10及以下浏览器，请使用更高版本的浏览器查看', '浏览器不兼容通知', {
                confirmButtonText: '确定'
            });
        } else {
            next();
        }
    }
})


new Vue({
    router,
    render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js